import { AlertController, Platform } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { TextServiceProvider } from '../text-service/text-service';

@Injectable()
export class AlertServiceProvider {
  private errorAlert = {
    title: this.textService.get('defaultErrorTitle'),
    subTitle: this.textService.get('defaultErrorText'),
    buttons: [this.textService.get('defaultErrorButton')],
  };
  private infoAlert = {
    title: this.textService.get('defaultInfoTitle'),
    subTitle: '',
    buttons: [this.textService.get('defaultInfoButton')],
  };

  constructor(
    private alertCtrl: AlertController,
    private plt: Platform,
    public textService: TextServiceProvider,
  ) {}

  showErrorAlert(content?, title?, buttons?) {
    let localAlert = this.errorAlert;
    localAlert.subTitle = content ? content : localAlert.subTitle;
    localAlert.title = title ? title : localAlert.title;
    localAlert.buttons = buttons ? buttons : localAlert.buttons;
    return this.alertCtrl.create(localAlert).present();
  }

  showInfoAlert(content?, title?) {
    let localAlert = this.infoAlert;
    localAlert.subTitle = content;
    localAlert.title = title ? title : localAlert.title;
    return this.alertCtrl.create(localAlert).present();
  }

  showNoConnAlert(onDidDismiss?) {
    let alert = this.alertCtrl.create({
      title: this.textService.get('networkErrorTitle'),
      message: this.textService.get('networkErrorText'),
      buttons: [this.textService.get('networkErrorButton')],
    });

    if (onDidDismiss) {
      alert.onDidDismiss(() => {
        onDidDismiss();
      });
    }
    alert.present();
  }

  showServiceDownError() {
    return this.showErrorAlert(
      this.textService.get('serviceNotReachable'),
      this.textService.get('serviceNotReachableTitle'),
    );
  }

  showServiceInternalError() {
    return this.showErrorAlert(
      this.textService.get('serviceInternalError') ||
        'Wystąpił błąd wewnętrzny',
      this.textService.get('serviceInternalErrorTitle') || 'Błąd',
    );
  }

  showUnexpectedError() {
    return this.showErrorAlert(
      this.textService.get('unexpectedError') || 'Wystąpił nieoczekiwany błąd',
      this.textService.get('serviceInternalErrorTitle') || 'Błąd',
    );
  }

  showUpdateAlert(onDidAction: Function) {
    let alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title: this.textService.get('newerVersionTitle'),
      message: this.textService.get('newerVersionText'),
      buttons: [
        {
          text: this.textService.get('newerVersionButton'),
          handler: () => onDidAction(),
        },
      ],
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/alert-service/alert-service.ts